import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { Gruppe } from '../../../gruppen/classes/gruppe';
import { UntypedFormControl } from '@angular/forms';
import { MessageService } from '../../../../services/message-service/message.service';
import { StammdatenService } from '../../../stammdaten/stammdaten.service';
import { TierGeschlecht } from '../../classes/tier-geschlecht';
import { OnChanges } from '@angular/core';

@Component({
    selector: 'kiene-gruppe-tier-geschlecht-filter',
    templateUrl: './gruppe-tier-geschlecht-filter.component.html',
    styleUrls: ['./gruppe-tier-geschlecht-filter.component.scss'],
})
export class GruppeTierGeschlechtFilterComponent implements OnInit, OnDestroy, OnChanges {
    geschlechterGruppeSubscription: Subscription;
    isLoading = true;
    label = 'Lädt...';

    @Input('gruppe') selectedGruppe: Gruppe;
    @Input() gruppeIds: number[] = [];
    @Input('geschlechter') geschlechter: TierGeschlecht[] = [];
    @Input('hideOnEmptyList') hideOnEmptyList = false;
    @Output('selectedGeschlechter') selectedGeschlechter: EventEmitter<TierGeschlecht[]> = new EventEmitter<
        TierGeschlecht[]
    >();
    selectedGeschlechtCtrl: UntypedFormControl = new UntypedFormControl(null);
    geschlechterFuerGruppe: TierGeschlecht[] = [];

    constructor(
        private messageService: MessageService,
        private stammdatenService: StammdatenService,
    ) {}

    ngOnDestroy(): void {
        this.geschlechterGruppeSubscription?.unsubscribe();
    }
    ngOnInit(): void {
        this.loadGeschlechterFuerGruppe();

        this.selectedGeschlechtCtrl.setValue(this.geschlechter);

        this.selectedGeschlechtCtrl.valueChanges.subscribe(data => {
            this.selectedGeschlechter.emit(data);
        });
    }

    ngOnChanges() {
        if (this.selectedGruppe || (this.gruppeIds || []).length > 0) {
            this.loadGeschlechterFuerGruppe();
        }
    }

    private loadGeschlechterFuerGruppe() {
        this.isLoading = true;
        const targetGroupIds =
            (this.gruppeIds || []).map(id => Number(id)).filter(id => id > 0).length > 0
                ? (this.gruppeIds || []).map(id => Number(id)).filter(id => id > 0)
                : this.selectedGruppe?.gruppe_id
                  ? [Number(this.selectedGruppe.gruppe_id)]
                  : [];
        if (targetGroupIds.length > 0) {
            this.geschlechterGruppeSubscription?.unsubscribe();
            const requests = targetGroupIds.map(gruppeId => this.stammdatenService.ladeGeschlechter(gruppeId));
            this.geschlechterGruppeSubscription = forkJoin(requests).subscribe({
                    next: result => {
                        this.selectedGeschlechtCtrl.enable();
                        this.isLoading = false;
                        const byId = new Map<number, TierGeschlecht>();
                        for (const res of result || []) {
                            for (const item of res?.records || []) {
                                const key = Number(item?.geschlecht_id || 0);
                                if (key <= 0 || byId.has(key)) {
                                    continue;
                                }
                                byId.set(key, item);
                            }
                        }
                        this.geschlechterFuerGruppe = Array.from(byId.values());
                        this.geschlechterFuerGruppe.sort((a, b) => {
                            return a.geschlecht_id < b.geschlecht_id ? -1 : 1;
                        });

                        if (this.geschlechterFuerGruppe.length === 0) {
                            this.label = 'keine Geschlechter';
                            this.selectedGeschlechtCtrl.disable();
                        } else {
                            this.label = 'Geschlecht';
                        }
                    },
                    error: err => {
                        this.messageService.errorMessage('Fehler beim Laden der Geschlechter', err);
                    },
                });
        }
    }

    resetGeschlechtCtrl($event: MouseEvent) {
        $event.stopPropagation();
        this.selectedGeschlechtCtrl.setValue(undefined);
    }

    compareGeschlecht(a: TierGeschlecht, b: TierGeschlecht) {
        return a && b && a.geschlecht_id === b.geschlecht_id;
    }
}
